'use strict';

module.exports = '3.20.2';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 37
// module chunks = 0